import React from 'react';
import { PropTypes } from 'prop-types';

import MenuDashboardItem from '../MenuDashboardItem';
import ExitToApp from 'components/CoreIcons/Icons/ExitToApp';

const MenuLogout = ({ onHandleLogout }) => {
  return (
    <div className='MenuLogout' onClick={onHandleLogout}>
      <MenuDashboardItem
        icon={
          <ExitToApp 
            fill='#1F35B5'
            height='20px'
            width='24px'
            viewBox='0 0 24 24'
          />
        }
        title='Sair'
      />
    </div>
  );
};

MenuLogout.propTypes = { onHandleLogout: PropTypes.func };

export default MenuLogout;
